import style from "modules/HRAccount/Divider/divider.module.scss"

export function Divider() {
    return <hr className={style.divider} />
}
